import { CategoryParams, MenuCategory, Product, ProductParams } from 'models';
import request from './axiosClient';
import { AxiosResponse } from 'axios';

const MENU_CATEGORY = '/product-category-public';
const MENU_PRODUCT = '/products-public';
const MENU_SET = '/set-menu-public';
export function getMenuCategoryApi(
  params: CategoryParams
): Promise<AxiosResponse<Array<MenuCategory>>> {
  return request({
    url: MENU_CATEGORY,
    method: 'get',
    params,
    noNeedToken: true,
  });
}
export function getMenuProductByCategoryApi(
  params: ProductParams
): Promise<AxiosResponse<Array<Product>>> {
  return request({
    url: MENU_PRODUCT,
    method: 'get',
    params,
    noNeedToken: true,
  });
}
// disable_app: [] (sản phẩm),
// category: disable_app: [] (cate),
export function getMenuSetApi(params: {
  shop_id: number;
  appName: string;
}): Promise<AxiosResponse<Array<Product>>> {
  return request({
    url: MENU_SET,
    method: 'get',
    params,
    noNeedToken: true,
  });
}
